// 箱单发票 이미지(营业执照·印章) 공용 — 生成箱单发票(InvoiceGenerator.vue)·营业执照管理(InvoiceLicenseList.vue)가 같이 쓴다.
// 서버: /api/coupassInvoiceImage/* (server.js 「箱单发票 이미지」 구역). 营业执照 은 화주 한 명에 여러 장(2026-10-04 YZY).

// 올리기 전에 브라우저에서 줄인다(서버 상한 3MB)
const IMG_MAX_SIDE = { seal: 800, license: 1600 };

// 파일 → { name, type, data(base64), width, height }. 도장은 투명 배경이 있어 PNG 유지, 사업자등록증은 JPEG.
export function shrinkImage(file, kind) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const max = IMG_MAX_SIDE[kind] || 1600;
        const r = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        const w = Math.max(1, Math.round(img.naturalWidth * r));
        const h = Math.max(1, Math.round(img.naturalHeight * r));
        const cv = document.createElement('canvas');
        cv.width = w;
        cv.height = h;
        const ctx = cv.getContext('2d');
        const type = kind === 'seal' ? 'image/png' : 'image/jpeg';
        if (type === 'image/jpeg') { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); }
        ctx.drawImage(img, 0, 0, w, h);
        const dataUrl = cv.toDataURL(type, 0.85);
        resolve({ name: file.name, type, data: dataUrl.split(',')[1], width: w, height: h });
      } catch (e) {
        reject(e);
      } finally {
        URL.revokeObjectURL(url);
      }
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('图片读取失败(이미지를 읽지 못했습니다)')); };
    img.src = url;
  });
}

// 营业执照 고르기 칸에 보일 이름 — 「화주 · 상호명(영문상호명)」. 상호명이 없으면 영문상호명, 둘 다 없으면 파일명
export function licenseText(l) {
  if (!l) return '';
  const ko = l.label || '';
  const en = l.labelEn || '';
  const name = ko && en ? ko + '(' + en + ')' : (ko || en || l.name || '营业执照');
  return l.companyid + ' · ' + name;
}
